import clsx from 'clsx';
// @ts-ignore
import {Tab} from '@headlessui/react';
import {Text} from '~/components/elements/Text';
import {twMerge} from 'tailwind-merge';
import {MouseEvent, useState} from 'react';
import {DATA_TEST_IDS} from '~/lib/const';

export const TabHeaderButton = ({
  index,
  selected,
  children,
  className,
}: {
  index: number;
  selected: boolean;
  children: React.ReactNode;
  className?: string;
}) => {
  return (
    <div
      data-testid={DATA_TEST_IDS.TAB_HEADER_BUTTON}
      className={index === 0 ? 'pr-[15px] xl:pr-5' : 'px-[15px] xl:px-5'}
    >
      <div
        className={twMerge(
          clsx(
            'border-b-[3px] border-transparent hover:border-gray-400 pb-[4px] xl:pb-[6px]',
            selected && 'border-blue-500 hover:border-blue-500',
          ),
        )}
      >
        <Text
          as={'h5'}
          className={clsx(
            'tracking-wider leading-[25px] font-bold xl:leading-[27px] hover:text-black',
            !selected && 'text-gray-400',
            className,
          )}
        >
          {children}
        </Text>
      </div>
    </div>
  );
};
export default function Tabs({
  className,
  titles,
  tabEnd,
  children,
  hideHeader = false,
  onChange,
}: {
  className?: string;
  titles?: Array<React.ReactNode>;
  tabEnd?: React.ReactNode;
  children: React.ReactNode;
  hideHeader?: boolean;
  onChange?: (index: number) => void;
}) {
  const [selectedIndex, setSelectedIndex] = useState(0);

  return (
    <div className={clsx(className)}>
      <Tab.Group selectedIndex={selectedIndex}>
        <Tab.List>
          <div
            data-testid={DATA_TEST_IDS.TAB_LIST}
            className={clsx(
              'flex',
              tabEnd ? 'justify-between' : 'justify-start',
            )}
          >
            <div>
              {titles?.map((title, index) => (
                <Tab
                  data-testid={DATA_TEST_IDS.TAB(index)}
                  key={typeof title === 'string' ? title : index}
                  // Arrows that comes from tabEnd are hidden before `md` sizes
                  className={clsx(
                    'outline-none',
                    tabEnd && 'md:pt-2.5',
                    hideHeader && 'hidden',
                  )}
                  onClick={(event: MouseEvent<HTMLButtonElement>) => {
                    event.preventDefault();
                    setSelectedIndex(index);
                    onChange?.(index);
                  }}
                >
                  {({selected}) => (
                    <TabHeaderButton index={index} selected={selected}>
                      {title}
                    </TabHeaderButton>
                  )}
                </Tab>
              ))}
            </div>
            {tabEnd}
          </div>
        </Tab.List>
        <Tab.Panels>{children}</Tab.Panels>
      </Tab.Group>
    </div>
  );
}
